import React, { useState, useEffect } from "react";
import HaberlerComponent from "../../component/Haberler";

const NewsSlide = () => {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    handleResize(); // İlk render'da da çalıştır
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  // Mobil ve tablet için tamamen farklı yaklaşım
  if (isMobile || isTablet) {
    return (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "calc(var(--app-vh, 1vh) * 100)",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          boxSizing: "border-box",
          overflow: "hidden",
          background: "transparent",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            overflow: "hidden",
          }}
        >
          <HaberlerComponent />
        </div>
      </div>
    );
  }

  // Desktop için orijinal stil
  return (
    <div
      className="news-slide-container"
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        zIndex: 2,
        display: "flex",
        alignItems: "stretch",
        justifyContent: "stretch",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          zIndex: 1,
        }}
      >
        <HaberlerComponent />
      </div>
    </div>
  );
};

export default NewsSlide;